import { BlockCreateProps } from "block-system/blocks/__shared__/types";
import { blockType } from "./constants";
import { AIGeneratedBlockSchema } from "./schema";
import { AIGenerated, AIGeneratedBlock } from "./types";

export function copy(block: AIGeneratedBlock): AIGeneratedBlock {
  return {
    ...block,
    config: {
      ...block.config,
      id: undefined,
    },
  };
}

export const create: AIGenerated["create"] = (
  props?: BlockCreateProps<AIGeneratedBlock>
) => {
  const defaultConfig: AIGeneratedBlock["config"] = {
    content: {
      type: "jsx",
      value: "",
      version: "1.0.0",
    },
    processedContent: {
      type: "js",
      value: "",
      version: "1.0.0",
    },
    style: {
      alignment: "center",
      width: "wide",
    },
  };

  return AIGeneratedBlockSchema.parse({
    type: blockType,
    config: {
      ...defaultConfig,
      ...props?.initialConfig,
    },
  });
};

export const map: AIGenerated["map"] = (block) => {
  return {
    type: blockType,
    config: {
      ...AIGeneratedBlockSchema.shape.config.parse(block.config),
      id: block.id,
    },
  };
};
